export default {
  startEndDateWarning: "End Date that is earlier than Start Date",
  outsideScenarioDatesWarning: "Outside Scenario Dates",
  performanceKpiSingleFlightHint: "Multiple flightings are not available for this Performance KPI.",
  campaignIdWarningHint: "Note: Campaign ID belongs to the exiting campaign.",
};
